const phoneTools = {
    initPhoneMask(element) {
        if (element) {
            phoneTools.initPhoneMaskItem(element)
        } else {
            $('.js_phone_input').each((i,el) => {
                phoneTools.initPhoneMaskItem(el)
            })
        }
    },

    initPhoneMaskItem(element) {
        const initialValue = $(element).attr('value') || '';

        let mask = new IMask(element, {
            mask: initialValue ? '+38 (\\000) 000-00-00' : '',
            lazy: false,
        })
        $(element).on('focus', function () {
            mask.updateOptions({
                mask: '+38 (\\000) 000-00-00',
            });
        })
        $(element).on('blur', function () {
            if ($(element).val().includes('_')) {
                mask.updateOptions({
                    mask: '',
                })
                $(element).val('')
            }
        })
    },

    setInputMask(element) {
        const mask = element.find('option:selected').attr('data-mask')
        const iso = element.find('option:selected').attr('data-iso')
        const maskValue = mask.replace(/#/g, '0')
        const maskNums = (mask.match(/#/g) || []).length
        const input = element.siblings('.js_phone_input_int')[0]
        const isoInput = element.siblings('.js_phone_input_iso')
        if (input.maskRef) {
            input.maskRef.updateOptions({
                mask: maskValue,
            });
            input.maskRef.updateValue();
        } else {
            input.maskRef = IMask(input, {
                mask: maskValue,
                lazy: false,
            });
        }
        $(input).attr('data-nums', maskNums)
        isoInput.val(iso)
        $(input).prop('disabled', false)
    },

    getPhoneCodes(select) {
        const phoneCodes = localStorage.getItem('phoneCodesJson');
        let codesParse = {}

        if (phoneCodes) {
            codesParse = JSON.parse(phoneCodes)
        } else {
            phoneTools.loadPhoneCodes().then(data => {
                localStorage.setItem('phoneCodesJson', JSON.stringify(data));
                codesParse = data
            })
        }

        let html = ''
        codesParse.forEach(el => {
            html += `<option value="${el.code}" data-mask="${el.mask}" data-iso="${el.iso}">${el.iso} ${el.code}</option>`
        })
        if (select) {
            select.append(html)
        } else {
            $('.js_select__phone-code').append(html)
        }

        phoneTools.initIntValue()
    },

    initIntValue(input) {
        if (input) {
            phoneTools.initIntValueItem(input)
        } else {
            $('.js_phone_input_int').each((i, el) => {
                phoneTools.initIntValueItem($(el))
            })
        }
    },

    initIntValueItem(input) {
        const iso = input.siblings('.js_phone_input_iso').val()
        if (iso) {
            const select = input.siblings('.js_select__phone-code')
            const code = new RegExp("^" + parseInt(select.find(`option[data-iso=${iso}]`).attr('value')))
            let phone = input.val()
            phone = phone.replace(code, '')
            input.val(phone)
            select.find(`option[data-iso=${iso}]`).prop('selected', true)
            phoneTools.setInputMask(select)
        }
    },

    loadPhoneCodes() {
        return fetch('demos/Template/js/omnipage/countries_new.json')
            .then(response => response.json())
    },
}

window.phoneTools = phoneTools

$(document).ready(function () {
    if ($('.js_phone_input').length) {
        phoneTools.initPhoneMask()
    }

    if ($('.js_phone_input_int').length) {
        phoneTools.getPhoneCodes()
    }

    $(document).on('change', '.js_select__phone-code', function () {
        phoneTools.setInputMask($(this))
    })
})